module.exports = __webpack_public_path__ + "img/first_bg.6208c7f.png";